import { render, staticRenderFns } from "./UserAccessList.vue?vue&type=template&id=1bdcbbb8&scoped=true&"
import script from "./UserAccessList.vue?vue&type=script&lang=js&"
export * from "./UserAccessList.vue?vue&type=script&lang=js&"
import style0 from "./UserAccessList.vue?vue&type=style&index=0&id=1bdcbbb8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bdcbbb8",
  null
  
)

export default component.exports